/**
 * Created by Administrador on 17/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenueProductionConnections',{
                parent: 'app',
                url: '/revenueProductionConnections?departureDate',
                params: {
                    departureDate: null
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProductionConnection/revenueProductionConnections.html',
                        controller: 'revenueProductionConnectionCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('revenueProductionConnections')
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            'connections' : ['specialConnectionService','$stateParams',
                                function(specialConnectionService, $stateParams){
                                    if ($stateParams.departureDate == null) {
                                        $stateParams.departureDate = (new Date()).getTime();
                                    }
                                    return specialConnectionService.getConnections(parseInt($stateParams.departureDate));
                            }]
                        }
                    }
                }
            })
    }
})();


